import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import NavLinks, { fileForRoute } from "./NavLinks";
import Terminal from "./Terminal";

const Wrapper = ({ children }: { children: React.ReactNode }) => {
  const [navOpen, setNavOpen] = useState(false);
  const [termOpen, setTermOpen] = useState(false);
  const location = useLocation();
  const file = fileForRoute(location.pathname);

  useEffect(() => {
    document.title = `ishak@ertem — ${file}`;
    setNavOpen(false);
  }, [location.pathname, file]);

  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      const target = e.target as HTMLElement;
      if (
        e.key === "`" &&
        !e.metaKey &&
        !e.ctrlKey &&
        !e.altKey &&
        target.tagName !== "INPUT" &&
        target.tagName !== "TEXTAREA"
      ) {
        e.preventDefault();
        setTermOpen((open) => !open);
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, []);

  return (
    <div className="window-outer">
      <div className="window">
        <header className="titlebar">
          <span className="traffic-light red" />
          <span className="traffic-light yellow" />
          <span className="traffic-light green" />
          <span className="titlebar-text">ishak@ertem — ~/portfolio</span>
          <button
            className="menu-toggle"
            aria-label="Toggle navigation"
            onClick={() => setNavOpen((open) => !open)}
          >
            ☰
          </button>
        </header>

        <div className="window-body">
          <nav className={`sidebar${navOpen ? " open" : ""}`}>
            <NavLinks />
          </nav>
          {navOpen && (
            <div className="backdrop" onClick={() => setNavOpen(false)} />
          )}

          <main className="content">
            <p className="breadcrumb">
              ~/portfolio/<span className="breadcrumb-file">{file}</span>
            </p>
            {children}
          </main>
        </div>

        {termOpen && <Terminal />}

        <footer className="statusbar">
          <span className="statusbar-mode">NORMAL</span>
          <span>⎇ main</span>
          <button
            className="statusbar-btn"
            onClick={() => setTermOpen((open) => !open)}
            aria-pressed={termOpen}
          >
            &gt;_ terminal
          </button>
          <span className="statusbar-right">utf-8 · {file}</span>
        </footer>
      </div>
    </div>
  );
};

export default Wrapper;
